import { render, staticRenderFns } from "./AddProjectSEO.vue?vue&type=template&id=1e620445"
import script from "./AddProjectSEO.vue?vue&type=script&lang=js"
export * from "./AddProjectSEO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports